<div class="p-4 bg-slate-700 flex flex-col items-center justify-center flex-auto bg-opacity-75 rounded">
  <!-- TODO GET RID OF MATERIAL DEPENDENCY ? -->
  <mat-spinner [diameter]="diameter"></mat-spinner>
  <span class="my-2">Načítám...</span>
</div>
